export default __webpack_public_path__ + "static/media/img2.fc77d1a6.jpg";